import { PlusOutlined } from "@ant-design/icons";
import {
  Form,
  Input,
  InputNumber,
  Select,
  Button,
  DatePicker,
  Upload,
  message,
  Row,
  Col,
} from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import UploadProfilePicture from "../../../components/UploadProfilePicture";
import S3UploadButton from "../../../components/S3UploadButton";

function AddPharmacists() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const API_URL = import.meta.env.VITE_API_URL;
  const accessToken = useSelector((state) => state.user.accessToken);
  const [pharmacies, setPharmacies] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [branchId, setBranchId] = useState();
  const [isBranchDisabled, setIsBranchDisabled] = useState(true);
  const [imageUrl, setImageUrl] = useState("");
  const [LicenseFile, setLicenseFile] = useState("");

  const userType = useSelector((state) => state.user?.user?.roleDetails?.id);
  const pharmacyDetails = useSelector((state) => state.user.pharmacyDetails);

  const handlePharmacyChange = async (value) => {
    console.log("Selected Pharmacy ID:", value);
    setIsBranchDisabled(false);
    setBranchList([]);
    setBranchId(null);
    form.setFieldsValue({ branch: undefined });

    let pharmacyID;
    if (userType === 4) {
      pharmacyID = pharmacyDetails.id;
    } else {
      pharmacyID = pharmacies.find((ph) => ph.id === value);
      console.log("jj", pharmacyID);
    }

    try {
      let responseBranches;
      if (userType === 4) {
        responseBranches = await axios.get(
          `${API_URL}pharmacies?id=${pharmacyID}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
      } else {
        responseBranches = await axios.get(
          `${API_URL}pharmacies?id=${pharmacyID.id}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
      }

      const pharmacyData = responseBranches.data.Pharmacy;

      // Check if the pharmacy is active, otherwise clear the branch list
      if (!pharmacyData.active) {
        setBranchList([]);
        return;
      }

      // Keep only active branches
      const activeBranches = pharmacyData.BranchesDetails.filter(
        (branch) => branch.active
      );

      setBranchList(activeBranches);

      console.log("Fetched Active Branches:", activeBranches);
    } catch (error) {
      console.error("Error fetching branches:", error);
      message.error("Failed to load branch data.");
    }
  };
  useEffect(() => {
    if (userType === 2 || userType === 4) {
      handlePharmacyChange();
    }
  }, [userType]);
  const handleBranchChange = (value) => {
    console.log(value);
    setBranchId(value);
  };
  // Button Browser file upload
  const props = {
    action: "", // Replace with the correct URL
    beforeUpload: (file) => {
      const isPNG = file.type === "image/png";
      const isJPG = file.type === "image/jpeg";
      if (!isPNG && !isJPG) {
        message.error(`${file.name} is not a PNG or JPG file`);
        return Upload.LIST_IGNORE;
      }
      return true;
    },
    onChange: (info) => {
      console.log(info.fileList);
    },
  };
  const fetchDropdownData = async () => {
    try {
      const pharmacyResponse = await axios.get(
        `${API_URL}pharmacies/get-pharmacies?limit=1000`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      // Filter only active pharmacies
      const activePharmacies = pharmacyResponse.data.Pharmacies.filter(
        (pharmacy) => pharmacy.active
      ) // Keep only active pharmacies
        .map((pharmacy) => ({
          id: pharmacy.id,
          name: pharmacy.name,
        }));

      setPharmacies(activePharmacies);
    } catch (error) {
      console.error("Error fetching pharmacies:", error);
      message.error("Failed to load Dropdown data.");
    }
  };

  const handleSubmit = async (values) => {
    const formattedData = {
      role: 2,
      firstName: values.Pharmacist_First_Name,
      lastName: values.Pharmacist_Last_Name,
      mobileNumber: values.contact,
      profilePicture: imageUrl,
      gender: values.Gender,
      position: values.Position,
      yearsOfExperience: values.experience,
      employmentStartDate: values.start_date
        ? values.start_date.format("YYYY-MM-DD")
        : null,
      licenseImage: LicenseFile,
      licenceExpiryDate: values.end.format("YYYY-MM-DD"),
      // address: {
      //     cityID: 1,
      //     district: values.district,
      //     street: values.street,
      //     boulevard: values.boulevard,
      //     floor: values.floor,
      //     apartment: values.apartment,
      // },
    };

    if (formattedData.profilePicture == "") {
      return message.error("Please add an image");
    }
    try {
      const response = await axios.post(`${API_URL}users`, formattedData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      console.log("response", response);
      try {
        const responseBranch = await axios.post(
          `${API_URL}Branches/addOnePharmacist`,
          {
            userId: response.data.createdUser.id,
            branchId: branchId,
          },
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        console.log("responseBranch", responseBranch);
        message.success("Pharmacist added successfully");
        setIsBranchDisabled(false);
        form.resetFields();
        navigate(-1);
      } catch (err) {
        console.error("Error while Adding in Branch", err);
        message.error("Failed to Adding in Branch.");
        setIsBranchDisabled(false);
      }
    } catch (error) {
      console.error("Error while adding pharmacist:", error);
      message.error(`Error: ${error.response?.data?.message || error.message}`);
    }
  };
  const handleCancel = () => {
    form.resetFields();
    navigate(-1);
  };
  useEffect(() => {
    fetchDropdownData();
  }, []);

  return (
    <div className="p-4 md:p-6 lg:p-8">
      <h1 className="text-xl md:text-2xl lg:text-3xl font-semibold mb-4 md:mb-6">Add Pharmacist</h1>

      <div className="bg-white p-4 md:p-6 lg:p-8 rounded-sm">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          style={{ width: "100%" }}
        >
          <Row gutter={[24, 24]}>
            <Col xs={24} sm={24} md={6} lg={6} xl={4} className="flex flex-col items-center mb-6 md:mb-0">
              <div className="mb-4 md:mb-6">
                <UploadProfilePicture
                  onChange={(url) => {
                    setImageUrl(url);
                  }}
                  value={imageUrl}
                />
                <p className="text-center mt-2 text-gray-500">Profile Picture</p>
              </div>
            </Col>

            <Col xs={24} sm={24} md={18} lg={18} xl={20}>
              <Row gutter={[16, 16]}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="First Name"
                    name="Pharmacist_First_Name"
                    rules={[
                      { required: true, message: "Please enter first name" },
                    ]}
                  >
                    <Input className="h-10" />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label="Last Name"
                    name="Pharmacist_Last_Name"
                    rules={[
                      { required: true, message: "Please enter last name" },
                    ]}
                  >
                    <Input className="h-10" />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label="Position"
                    name="Position"
                    rules={[
                      { required: true, message: "Please enter position" },
                    ]}
                  >
                    <Input className="h-10" />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label="Years of Experience"
                    name="experience"
                    rules={[
                      { required: true, message: "Please enter experience years" },
                    ]}
                  >
                    <InputNumber min={0} className="w-full h-10" />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label="Contact Number"
                    name="contact"
                    rules={[
                      { required: true, message: "Please enter contact number" },
                      {
                        pattern: /^[0-9]{11}$/,
                        message: "Contact number must be exactly 11 digits",
                      },
                    ]}
                  >
                    <Input className="h-10" maxLength={11} />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label="Start Date"
                    name="start_date"
                    rules={[
                      { required: true, message: "Please select start date" },
                    ]}
                  >
                    <DatePicker className="w-full h-10" />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label="Gender"
                    name="Gender"
                    rules={[
                      { required: true, message: "Please select gender" },
                    ]}
                  >
                    <Select className="h-10">
                      <Select.Option value="MALE">Male</Select.Option>
                      <Select.Option value="FEMALE">Female</Select.Option>
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label="License Expiry Date"
                    name="end"
                    rules={[
                      { required: true, message: "Please select license expiry date" },
                    ]}
                  >
                    <DatePicker className="w-full h-10" />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[16, 16]}>
                <Col xs={24}>
                  <Form.Item
                    label="License Image"
                    name="licenseImage"
                  >
                    <div className="w-full border border-gray-200 p-4 rounded">
                      <S3UploadButton
                        onUpload={(url) => {
                          setLicenseFile(url);
                        }}
                      />
                      {LicenseFile && (
                        <div className="mt-2">
                          <img src={LicenseFile} alt="License" className="max-w-full h-auto max-h-40" />
                        </div>
                      )}
                    </div>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[16, 16]}>
                <Col xs={24}>
                  <h3 className="text-lg font-medium mb-4">Branch Details</h3>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label="Pharmacy"
                    name="pharmacy"
                    rules={[
                      { required: true, message: "Please select pharmacy" },
                    ]}
                  >
                    <Select
                      placeholder="Select Pharmacy"
                      onChange={handlePharmacyChange}
                      className="h-10"
                      disabled={userType === 4}
                    >
                      {userType === 4 ? (
                        <Select.Option value={pharmacyDetails.id}>
                          {pharmacyDetails.name}
                        </Select.Option>
                      ) : (
                        pharmacies.map((pharmacy) => (
                          <Select.Option key={pharmacy.id} value={pharmacy.id}>
                            {pharmacy.name}
                          </Select.Option>
                        ))
                      )}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label="Branch"
                    name="branch"
                    rules={[
                      { required: true, message: "Please select branch" },
                    ]}
                  >
                    <Select
                      placeholder="Select Branch"
                      onChange={handleBranchChange}
                      className="h-10"
                      disabled={isBranchDisabled}
                    >
                      {branchList.map((branch) => (
                        <Select.Option key={branch.id} value={branch.id}>
                          {branch.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="mt-6">
            <Col xs={24} className="flex flex-col sm:flex-row justify-end gap-3">
              <Button
                onClick={handleCancel}
                className="mb-3 sm:mb-0 h-10 px-6"
              >
                Cancel
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                className="h-10 px-6"
              >
                Add Pharmacist
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
}

export default AddPharmacists;
